import { TourModule } from "training/types";

/**
 * CLE-3015 — what each module is about: the title and one-sentence purpose the popover shows (the title on
 * every step, both on a module's first step). Titles are the curriculum's module names.
 */
export const MODULES: Record<TourModule, { title: string; purpose: string }> = {
  1: {
    title: "Logging in and the Estimates page",
    purpose:
      "Find your way around the home page and learn what each status means.",
  },
  2: {
    title: "Creating and sending an estimate",
    purpose:
      "Build a real estimate for yourself and send it to your own phone.",
  },
  3: {
    title: "Finding, viewing and editing an estimate",
    purpose:
      "Open an estimate, see what can be changed in place, and what needs a redo.",
  },
  4: {
    title: "Collecting a payment at the desk",
    purpose: "Walk to the screen where you would take a card, and stop there.",
  },
  5: {
    title: "Payment plans, refunds, cancelling and outreach",
    purpose:
      "Where plans are edited, where refunds live, and how to stop texts.",
  },
  6: {
    title: "Tracking an estimate, notes and reports",
    purpose:
      "Where to look when a patient calls, where to write it down, and where the money shows up.",
  },
};
